<template lang="pug">
v-app-bar(color="accent", dark, app)
  v-app-bar-nav-icon(
    color="white",
    class="d-flex d-md-none",
    @click="$emit('open-drawer', true)"
  )

  v-toolbar-title Micropet Id

  v-spacer

  .d-none.d-md-flex
    v-btn.btn-nav(
      v-if="user && admin",
      v-for="(nav, i) in nav_admin",
      :to="nav.path",
      :key="i",
      link,
      text,
      small
    ) {{ nav.text }}
    v-btn.btn-nav(
      v-if="user && vet",
      v-for="(nav, i) in nav_vet",
      :to="nav.path",
      :key="i",
      link,
      text,
      small
    ) {{ nav.text }}
    v-btn.btn-nav(
      v-if="user && owner",
      v-for="(nav, i) in nav_owner",
      :to="nav.path",
      :key="i",
      link,
      text,
      small
    ) {{ nav.text }}

  v-btn.btn-login(
    rounded,
    color="secondary"
    @click="authManager"
  ) {{ user && auth_token ? 'Cerrar Sesión' : 'Iniciar Sesión' }}
</template>

<script>
import { mapState } from "vuex";
import ViewPet from "@/components/pets/ViewPet.vue";
import UserMenu from "@/components/layouts/UserMenu.vue";

export default {
  name: "header-micropet",
  computed: {
    ...mapState({
      user: state => state.auth.user,
      auth_token: state => state.auth.auth_token
    }),
    admin() {
      return this.user.role.slug == "admin";
    },
    vet() {
      return this.user.role.slug == "vet";
    },
    owner() {
      return this.user.role.slug == "owner";
    }
  },
  components: {
    ViewPet,
    UserMenu
  },
  data() {
    return {
      pet_code: null,
      nav_admin: [
        { icon: "fa-paw", text: "Mascotas", path: "/pets" },
        { icon: "fa-cubes", text: "Stock", path: "/stock" },
        { icon: "fa-users", text: "Usuarios", path: "/users" },
        { icon: "fa-dog", text: "Especies", path: "/species" },
        { icon: "fa-boxes", text: "Inventario", path: "/inventories" },
        { icon: "fa-truck-loading", text: "Proveedores", path: "/providers" }
      ],
      nav_vet: [
        { icon: "fa-paw", text: "Mascotas", path: "/pets" },
        { icon: "fa-users", text: "Propietarios", path: "/users" },
        { icon: "fa-boxes", text: "Inventario", path: "/inventories" },
        { icon: "fas fa-syringe", text: "Vacunas", path: "/vaccinations" },
        {
          icon: "fa-calendar-alt",
          text: "Citas Médicas",
          path: "/appointments"
        },
        {
          icon: "fas fa-plus-square",
          text: "Historial Médico",
          path: "/medical_histories"
        }
      ],
      nav_owner: [
        { icon: "fa-paw", text: "Mis Mascotas", path: "/pets" },
        {
          icon: "fa-calendar-alt",
          text: "Mis Citas Médicas",
          path: "/appointments"
        }
      ]
    };
  },
  methods: {
    authManager() {
      if (this.user && this.auth_token) {
        window.localStorage.removeItem("user");
        window.localStorage.removeItem("auth_token");
        this.$store.commit("auth/setUser", null);
        this.$store.commit("auth/setTokenAuth", null);
        window.location.href = process.env.VUE_APP_URL;
      } else {
        this.$router.push("/auth/login");
      }
    },
    async searchPet() {
      if (this.pet_code) {
        if (this.$route.name == "SearchPet") {
          this.$router.replace(`/search_pet/?code=${this.pet_code}`);
          window.location.reload();
        } else this.$router.push(`/search_pet/?code=${this.pet_code}`);
      } else {
        this.$swal({
          icon: "error",
          title: "Por favor, ingrese el código de una mascota"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-login {
  margin-left: 10px;
}

.btn-nav {
  margin-left: 5px;
}
</style>
